
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Les démocrates-chrétiens ont défié les prévisions et ne perdent que 0,2%. Le PDC réunit désormais 11,4% de l'électorat. Dans ses terres d'origine, notamment dans le canton de Lucerne, le PDC s'est révélé convaincant, ce que l'on peut voir de manière impressionnante sur la carte. En dehors, cependant, il est clairement perdant. `}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;